import { render, staticRenderFns } from "./BaseFiltersSize.vue?vue&type=template&id=4763ab84&"
import script from "./BaseFiltersSize.vue?vue&type=script&lang=js&"
export * from "./BaseFiltersSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4763ab84')) {
      api.createRecord('4763ab84', component.options)
    } else {
      api.reload('4763ab84', component.options)
    }
    module.hot.accept("./BaseFiltersSize.vue?vue&type=template&id=4763ab84&", function () {
      api.rerender('4763ab84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseFiltersSize.vue"
export default component.exports